import { inject } from '@angular/core';
import {Router} from '@angular/router';
import { AuthService } from '../services/auth.service';

export const guestGuard = (): boolean => {
  if (inject(AuthService).token) {
    void inject(Router).navigate(['/']);
    return false;
  }

  return true;
}
